import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { Env, getProcessEnvironmentValue } from '@gif/shared-global';
import { useUser } from '@gif/shared-rtk';
import { useAppSelector, useAppDispatch } from '../../store';

/* eslint-disable-next-line */
export interface BootstrapProps {}

const environment = (getProcessEnvironmentValue('APP_ENV') || 'prod') as Env;

// When client loads on App, load vendor data and store in state
export function Bootstrap(props: BootstrapProps) {
  const { loadUser, user } = useUser({
    useAppSelector,
    useAppDispatch,
  });

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  // Initialize Datadog Rum Monitoring
  useEffect(() => {
    if (environment && environment !== 'local') {
      datadogRum.init({
        applicationId: '3fb352fc-9530-4b29-9307-d4e98d405034',
        clientToken: 'pub5637a8bdede7b98df4e7f9c320dcf5a0',
        site: 'us5.datadoghq.com',
        service: 'mlb-play-web',
        version: '2.1.0',
        env: environment,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 5,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        silentMultipleInit: true,
      });
    }
  }, []);
  // set user info for datadog if available
  useEffect(() => {
    if (user?.idToken?.claims?.email) {
      datadogRum.setUser({
        id: user?.accessToken?.claims?.uid,
        email: user?.idToken?.claims?.email,
      });
    }
  }, [user]);
  // End Datadog Rum Monitoring Initializing

  return null;
}

export default Bootstrap;
